export default "__VITE_ASSET__CgTb7Nax__"